/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic, IEntityAlert, ITranslatedObj} from "../../../../models/common";
import {ValidatorFn, ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";
import {Utils} from "../../../../common/utils";
import {IInput, IOutput, ISingleOutput, ISpec} from "../../../../models/ISpec";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";

export class Validator_DcDc_Viper extends Validator_DcDc_Buck {

  private static power(outs: IOutput<number>, i: number = -1): number {
    return outs.outputs.reduce((acc: number, curr: ISingleOutput<number>, idx: number) => (Utils.isValueReal(curr.power) && idx !== i) ? acc + curr.power : acc, 0);
  }

  private static getMaxLimPower(ic: Ic, vin: IInput<number>) {
    const IdLim: number = .95 * Utils.getFieldValue(ic, 'designData.ILIM_min', 0);
    const maxLimPower: number = IdLim / 2 * 0.45 * 0.75 * (Utils.isValueReal(vin.min) ? vin.min : ic.vin_min);
    return maxLimPower;
  }

  private validatorFn_SingleOutput_Voltage_Viper_FirstOutput: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    if (Utils.isValueReal(spec.spec.value.input.min) && o === 0) {
      const _vOut = spec.spec.value.output.outputs[o].voltage;
      if (_vOut < 0) {
        result = { key : "first output must be positive" };
      }
    }
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Voltage_Viper: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;

    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const _power = Validator_DcDc_Viper.power(spec.spec.value.output);
    const maxLimPower = Validator_DcDc_Viper.getMaxLimPower(ic, spec.spec.value.input);

    result = Utils.acceptGreaterThan(Math.abs(_vOut), ic.vout_min, "Vout", "V");
    if (_power > maxLimPower) {
      result = Utils.acceptUpTo(_power, ValueFormatter.scale(maxLimPower, siPrefix.unit), "Output Power", "W");
    }
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_Viper: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;

    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const _iOut = spec.spec.value.output.outputs[o].current;
    const _power = Validator_DcDc_Viper.power(spec.spec.value.output);
    const maxLimPower = Validator_DcDc_Viper.getMaxLimPower(ic, spec.spec.value.input);
    const maxSinglePowers = maxLimPower - Validator_DcDc_Viper.power(spec.spec.value.output, o);

    const maxIout = ValueFormatter.scale(
      ValueFormatter.scale(maxSinglePowers / (Utils.isValueEmpty(_vOut) ? ic.vout_min : Math.abs(_vOut)), siPrefix.unit, 2, "c")
      , siPrefix.unit);

    result = Utils.acceptUpTo(_iOut, maxIout, "Iout", "A");

    if (_power > maxLimPower) {
      result = Utils.acceptUpTo(_power, ValueFormatter.scale(maxLimPower, siPrefix.unit), "Output Power", "W");
    }
    return new EntityError(result);
  }

  // private validatorFn_SingleOutput_Power_Viper:ValidatorFn = (ic:Ic, spec:IAppSpec):IEntityAlert => {
  //   let result = null;
  //   const _power = Validator_DcDc_Viper.power(spec.spec.value.output);
  //   const maxLimPower = Validator_DcDc_Viper.getMaxLimPower(ic, spec.spec.value.input);
  //
  //   if (_power > maxLimPower) {
  //     result = Utils.acceptUpTo(_power, ValueFormatter.scale(maxLimPower, siPrefix.unit), "Output Power", "W");
  //   }
  //
  //   return new EntityError(result === null ? "" : result );
  //
  // };

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_Viper_FirstOutput, this.validatorFn_SingleOutput_Voltage_Viper];
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_Viper];
  }

  // protected globalOutputP():ValidatorFn[] {
  //   return [this.validatorFn_SingleOutput_Power_Viper];
  // }
}
